import { CreateProductReviewModalData } from '@zyro-inc/site-modules/types';
import { SiteBlock } from '@hostinger/builder-schema-validator/schema/schemaTypes';
import { ref } from 'vue';

const createProductReviewData = ref<CreateProductReviewModalData | undefined>();
const openEcommerceModalName = ref<string>('');
const productPreviewData = ref<SiteBlock | undefined>();
const quickPreviewProductId = ref<string>('');

export const useEcommerceModal = () => {
	const openEcommerceModal = (name: string) => {
		openEcommerceModalName.value = name;
	};

	const closeEcommerceModal = () => {
		openEcommerceModalName.value = '';
	};

	const setProductPreviewData = (blockData: SiteBlock, productId: string) => {
		productPreviewData.value = blockData;
		quickPreviewProductId.value = productId;
	};

	const setCreateProductReviewData = (reviewData: CreateProductReviewModalData | undefined) => {
		createProductReviewData.value = reviewData;
	};

	return {
		openEcommerceModal,
		closeEcommerceModal,
		createProductReviewData,
		openEcommerceModalName,
		productPreviewData,
		quickPreviewProductId,
		setCreateProductReviewData,
		setProductPreviewData,
	};
};
